import { ContentContext, LocaleContext } from 'Components/hooks/context';
import React, { useContext, useEffect } from 'react';

import CovidWave from '@reuters-graphics/chart-module-covidwave';
import NoteBox from 'Components/common/NoteBox';
import RenderedString from 'Components/common/RenderedString';
import SmartText from '@reuters-graphics/react-smart-text';
import { component } from './styles.module.scss';
import debounce from 'lodash/debounce';
import useWindowDimensions from 'Components/hooks/useWindowDimensions';

const chart = new CovidWave();

const FlatteningCurve = ({ globalStatistics }) => {
  const { distributionRanks } = globalStatistics;
  const { cases } = distributionRanks;

  const locale = useContext(LocaleContext);
  const content = useContext(ContentContext);
  const { width: windowWidth } = useWindowDimensions();

  const chartContainer = React.createRef();

  const resize = debounce(() => {
    if (!chartContainer.current) return;
    chart
      .props({
        height: windowWidth < 600 ? 150 : 200,
      })
      .draw();
  }, 250);

  useEffect(() => {
    chart
      .selection(chartContainer.current)
      .data(cases)
      .props({
        locale,
        height: windowWidth < 600 ? 150 : 200,
        thresholdDomain: [0.75, 0.9],
        thresholdRange: {
          color: ['#ccc', '#f68e26', '#de2d26'],
          opacity: [0.1, 0.2, 0.4],
        },
        thresholdText: content.template.flatteningCurve.threshold,
        peakText: {
          ofPeak: content.template.flatteningCurve.ofPeak,
          atPeak: content.template.flatteningCurve.atPeak,
        },
        legendText: {
          max: content.template.flatteningCurve.legendMax,
          min: content.template.flatteningCurve.legendMin,
        },
      })
      .draw();
    return () => chart.destroy();
  }, [windowWidth, locale, cases, content, chartContainer]);

  useEffect(() => {
    window.addEventListener('resize', resize);
    return () => window.removeEventListener('resize', resize);
  }, [resize]);

  return (
    <div className={component}>
      <h2>
        <RenderedString source={content.template.flatteningCurve.title} context={{}} />
      </h2>
      <SmartText source={content.template.flatteningCurve.intro} multiline />
      <NoteBox
        title={content.template.flatteningCurve.note.title}
        source={content.template.flatteningCurve.note.text}
      />
      <div className='covid-wave-chart-container' ref={chartContainer} />
    </div>
  );
};

export default FlatteningCurve;
